import { toast } from 'sonner';
import SolutionPickerModal from '@/components/modals/SolutionPickerModal';
import type { SolutionGalleryItem } from '@/features/database/solution/types';
import { useAddToPalette } from '../api';
import type { PaletteItem, PaletteKind } from '../types';

const TITLES: Record<PaletteKind, string> = {
  pattern: 'Přidat dezén do palety',
  finish: 'Přidat úpravu povrchu do palety',
};

export function PaletteCatalogPicker({
  kind,
  modelId,
  onClose,
  onAdded,
}: {
  kind: PaletteKind;
  modelId: string;
  onClose: () => void;
  onAdded: (item: PaletteItem) => void;
}) {
  const add = useAddToPalette(kind);
  const submit = async (picked: SolutionGalleryItem) => {
    // The palette is keyed by the classified placement (`id`), never by `id_detail`.
    const { item, created } = await add.mutateAsync({
      model: modelId,
      classifiedSolution: picked.id,
    });
    toast.success(
      created ? `${item.code} přidáno do palety` : `${item.code} už je v paletě modelu`,
      { description: item.title }
    );
    onAdded(item);
  };
  return (
    <SolutionPickerModal
      visible
      kind={kind}
      title={TITLES[kind]}
      classificationId={null}
      onClose={onClose}
      onSubmit={(picked) => {
        submit(picked).catch(() => undefined);
      }}
    />
  );
}
